import { Link } from "react-router-dom";
import { BookOpen, ClipboardCheck, Home, User, type LucideIcon } from "lucide-react";

type TabKey = "home" | "courses" | "practice" | "profile";

interface Tab {
  key: TabKey;
  label: string;
  icon: LucideIcon;
  to: string | null;
}

const TABS: Tab[] = [
  { key: "home", label: "Главная", icon: Home, to: "/" },
  { key: "courses", label: "Курсы", icon: BookOpen, to: "/my-courses" },
  // Полевая практика — v1.1; пока неактивна
  { key: "practice", label: "Практика", icon: ClipboardCheck, to: null },
  { key: "profile", label: "Профиль", icon: User, to: "/profile" },
];

interface Props {
  active: TabKey;
}

export function MobileTabBar({ active }: Props) {
  return (
    <nav
      aria-label="Основная навигация"
      className="fixed inset-x-0 bottom-0 z-20 border-t border-line bg-white/95 backdrop-blur md:hidden"
    >
      <ul className="mx-auto grid max-w-3xl grid-cols-4">
        {TABS.map((t) => {
          const Icon = t.icon;
          const isActive = t.key === active;
          const className = `flex flex-col items-center gap-0.5 py-2.5 text-[11px] transition ${
            isActive
              ? "text-brand"
              : t.to === null
                ? "text-ink-muted/40"
                : "text-ink-muted hover:text-ink"
          }`;
          return (
            <li key={t.key}>
              {t.to ? (
                <Link to={t.to} className={className} aria-current={isActive ? "page" : undefined}>
                  <Icon size={20} strokeWidth={isActive ? 2.25 : 1.75} />
                  <span className="font-medium">{t.label}</span>
                </Link>
              ) : (
                <span className={className} aria-disabled="true">
                  <Icon size={20} strokeWidth={1.75} />
                  <span className="font-medium">{t.label}</span>
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
